// extracted by mini-css-extract-plugin
export default {"container":"AF-z","modal":"BF-z","dimensions":"CF-z","brandName":"DF-z","productName":"EF-z","recipientEmail":"FF-z","recommendedFit":"GF-z","hiddenField":"HF-z"};